/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GeneralError,
  RemoteConfigurationRepositoryType,
  UserStoryTelling
} from '51trips-frontend-core'
import { fetchAndActivate, getValue } from 'firebase/remote-config'
import { Observable } from 'rxjs'

import { remoteConfig } from '../firebase'
import remoteConfigConverter from './converters/RemoteConfigConverter'

export class RemoteConfigurationRepository implements RemoteConfigurationRepositoryType {
  setRemoteConfigurationSettings(): Observable<void> {
    return new Observable((subscriber) => {
      remoteConfig.settings.minimumFetchIntervalMillis = 14400000
      subscriber.next()
      subscriber.complete()
    })
  }

  fetchRemoteConfiguration(): Observable<Record<string, any>> {
    return new Observable((subscriber) => {
      fetchAndActivate(remoteConfig)
        .then(() => {
          subscriber.next(remoteConfig.defaultConfig)
          subscriber.complete()
        })
        .catch((error) => {
          subscriber.error(
            new GeneralError('Remote Config fetch did not work as expected. ', undefined, error)
          )
        })
    })
  }

  get tripBookPreviewURL(): string {
    return getValue(remoteConfig, 'tripBookPreviewURL').asString()
  }

  get tripBookOrderPreviewURL(): string {
    return getValue(remoteConfig, 'tripBookOrderPreviewURL').asString()
  }
  get tripBookPDFURL(): string {
    return getValue(remoteConfig, 'tripBookPDFURL').asString()
  }

  get tripAPI(): string {
    return getValue(remoteConfig, 'tripAPI').asString()
  }

  get tripBookBaseURL(): string {
    return getValue(remoteConfig, 'tripBookBaseURL').asString()
  }

  get imageQualityOnResize(): number {
    return getValue(remoteConfig, 'imageQualityOnResize').asNumber()
  }

  get minimumMegapixelsPerUserImage(): number {
    return getValue(remoteConfig, 'minimumMegapixelsPerUserImage').asNumber()
  }

  get minimumMegapixelsPerTripCoverImage(): number {
    return getValue(remoteConfig, 'minimumMegapixelsPerTripCoverImage').asNumber()
  }

  get minimumMegapixelsPerTripDayImage(): number {
    return getValue(remoteConfig, 'minimumMegapixelsPerTripDayImage').asNumber()
  }
  get userStorytellingData(): UserStoryTelling[] {
    const data = getValue(remoteConfig, 'userStorytellingData').asString()
    if (data && typeof data === 'string') {
      return remoteConfigConverter.fromRemoteConfig.userStorytellingData(JSON.parse(data))
    }
    return []
  }

  get userStorytellingURL(): string {
    return getValue(remoteConfig, 'userStorytellingURL').asString()
  }

  get serverBaseURL(): string {
    return getValue(remoteConfig, 'serverBaseURL').asString()
  }

  get tripBookPreviewHandlerURL(): string {
    return getValue(remoteConfig, 'tripBookPreviewHandler').asString()
  }

  get exploreActivitiesURL(): string {
    return getValue(remoteConfig, 'exploreActivitiesURL').asString()
  }

  get minimumMegabytesPerTripCoverImage(): number {
    return getValue(remoteConfig, 'minimumMegabytesPerTripCoverImage').asNumber()
  }

  get minimumMegabytesPerTripDayImage(): number {
    return getValue(remoteConfig, 'minimumMegabytesPerTripDayImage').asNumber()
  }
  get minimumMegabytesPerUserImage(): number {
    return getValue(remoteConfig, 'minimumMegabytesPerUserImage').asNumber()
  }

  get understandingImpactOfUsingWhatsappURL(): string {
    return getValue(remoteConfig, 'understandingImpactOfUsingWhatsappURL').asString()
  }
}
